module.exports = __webpack_public_path__ + "static/media/uzytkownicy-mediow-spolecznosciowych.8d9abc60.pdf";